import Phaser from 'phaser';
import { BootScene } from '@/scenes/BootScene';
import { PreloadScene } from '@/scenes/PreloadScene';
import { AuthScene } from '@/scenes/AuthScene';
import { ProfileSelectScene } from '@/scenes/ProfileSelectScene';
import { AdminPanelScene } from '@/scenes/AdminPanelScene';
import { MenuScene } from '@/scenes/MenuScene';
import { GameScene } from '@/scenes/GameScene';
import { ResultScene } from '@/scenes/ResultScene';
import { WorldMapScene } from '@/scenes/WorldMapScene';
import { LevelMapScene } from '@/scenes/LevelMapScene';
import { TrainingPickScene } from '@/scenes/TrainingPickScene';
import { TrainingScene } from '@/scenes/TrainingScene';
import { TrainingResultScene } from '@/scenes/TrainingResultScene';
import { TimeAttackScene } from '@/scenes/TimeAttackScene';
import { TimeAttackResultScene } from '@/scenes/TimeAttackResultScene';

/**
 * Configuração global do Phaser.
 *
 * Resoluções escolhidas conforme CLAUDE.md §8 (mobile-first): jogo desenhado
 * em 1280x720 e escalado por FIT, com clamp em 360x640..1920x1080 para
 * respeitar telas pequenas e desktops grandes.
 */
export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#0b0b1a',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1280,
    height: 720,
    min: { width: 360, height: 640 },
    max: { width: 1920, height: 1080 },
  },
  // Pixel art futura precisa de antialiasing desligado; manter true por enquanto
  // até definirmos o estilo final dos sprites (ver docs/ART_STYLE.md).
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
  },
  // Habilita scene.add.dom — usado pela AuthScene pra inputs HTML reais
  // (text/email/password) com autocomplete e suporte a teclado nativo.
  dom: {
    createContainer: true,
  },
  scene: [
    BootScene,
    PreloadScene,
    AuthScene,
    ProfileSelectScene,
    AdminPanelScene,
    MenuScene,
    WorldMapScene,
    LevelMapScene,
    GameScene,
    ResultScene,
    TrainingPickScene,
    TrainingScene,
    TrainingResultScene,
    TimeAttackScene,
    TimeAttackResultScene,
  ],
};
